import { createContext, useState } from'react';

const UserContext = createContext({
	user: {email: 'NONE'},
	signups: [],
	updateUser: (data) => {}
});

export function UserContextProvider(props) {
	const [theUser, setUser] = useState([]);
	const [signups, setSignups] = useState([]);

	function UpdateUserDataHandler( data ) {
		const tempUser = {
			email: data.email,
            firstName: data.firstName,
            lastName: data.lastName
		}
		setUser(tempUser);
	}

	function setSignupsHandler(data) {
        setSignups(data);
    }

	const context = {
		user: theUser,
        updateUser: UpdateUserDataHandler,
		signups: signups,
        setSignups: setSignupsHandler
	};

    return (
        <UserContext.Provider value={context}>
            {props.children}
        </UserContext.Provider>
    );
}

	export default UserContext;